﻿import { Component} from '@angular/core';
import { Tabla } from 'src/app/_components/tabla';


@Component({ templateUrl: 'lista.component.html' })
export class RootPedidoComponent {

    data: any;

    tabla: Tabla = {
        titulo: 'Listas',
        hideHeader: false,
        hideFilter: false,
        externalData: false,
        endPoint: '/rest-api/root/pedido',
        editable: true,
        nuevo: false,
        routeLink: '/user/lista', 
        columnas: [
            {
                name: 'id',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 75,
                hidden: false
            },
            {
                name: 'Lista',
                prop: 'listaId',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 75
            },
            {
                name: 'De',
                prop: 'de',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Total',
                prop: 'total',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Pagado',
                prop: 'pagado',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            }
        ]
    };

    constructor() {}

}
